/**
 * TrainingStep — step 2 content (016 Onboarding Wizard, spec FR-002).
 *
 * Placeholder illustration per spec OQ-03; copy lives in the i18n bundle
 * (`onboarding.step.training.title|body`).
 */

import type { JSX } from 'react';

import trainingIllustration from '../../assets/onboarding-education.png';

const imageClasses = 'w-full h-auto max-h-onboarding-illustration object-contain rounded-2xl';

export function TrainingStep(): JSX.Element {
  return <img src={trainingIllustration} alt="" className={imageClasses} draggable={false} />;
}
